import React from 'react';

function PharmacyClaimIcon({
  width = 24,
  height = 24,
  ...rest
}: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 60 60"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}>
      {/* Document Outline */}
      <rect x="8" y="8" width="32" height="48" rx="2" ry="2" />
      <line x1="16" y1="20" x2="30" y2="20" />
      <line x1="16" y1="28" x2="30" y2="28" />
      <line x1="16" y1="36" x2="30" y2="36" />
      <line x1="16" y1="44" x2="30" y2="44" />

      {/* Cross Icon */}
      <path d="M24 12 h4 v4 h4 v4 h-4 v4 h-4 v-4 h-4 v-4 h4 z" />

      {/* Pill Icon */}
      <ellipse cx="46" cy="46" rx="12" ry="8" />
      <line x1="40" y1="40" x2="52" y2="52" />
    </svg>
  );
}

export default PharmacyClaimIcon;
